
// import React, { useState } from 'react';
// import './Card.css';
// import './Dashboard.css';
// import profitImage from '../../Assets/Icon-Profit.png';
// import lossImage from '../../Assets/Icon-Loss.png';



// const Card = ({ title, amount, image, change, category, label }) => {
//   const [isHovered, setIsHovered] = useState(false);
//   const expenseIndicatorImage = change > 0 ? profitImage : lossImage;
//   const expenseIndicatorColor = change > 0 ? "green" : "red";

//   return (
//     <div
//       className={`card ${isHovered ? 'card--hovered' : ''}`}
//       onMouseEnter={() => setIsHovered(true)}
//       onMouseLeave={() => setIsHovered(false)}
//     >
//       {/* Add the label element here */}
//       <div className="card__label">{category}</div>

//       <div className="title">
//         {/* <label>{category}</label> */}
//         <div className="title__text">
//           <label>Total Spend</label>
//           <p>{title}</p>
//           <div className="amount_text">
//             <p> ₹{amount}</p>
//           </div>
//         </div>
//         <div className="image-info">
//           {image && <img src={image} alt={`${title} img-info`} className="title__image" />}
//           <div className="profit-loss">
//             <p style={{ color: expenseIndicatorColor }}>
//               {change > 0 ? `+${change}%` : `${change}%`}
//             </p>
//             <img
//               src={expenseIndicatorImage}
//               alt={change > 0 ? { profitImage } : { lossImage }}
//               className="card__expense-indicator"
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Card;




import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { HugeiconsIcon } from '@hugeicons/react';
import { Car05Icon, Dress05Icon, FlashIcon, Motorbike02Icon, ShoppingCart02Icon, TradeDownIcon, TradeUpIcon, TvSmartIcon } from '@hugeicons/core-free-icons';


const categoryIconMap = {
  car: Car05Icon,
  bike: Motorbike02Icon,
  electricity: FlashIcon,
  electronics: TvSmartIcon,
  clothing: Dress05Icon,
  groceries: ShoppingCart02Icon,
};

const Card = ({ title, amount, image, change, category }) => {
  const [isHovered, setIsHovered] = useState(false);
  const ExpenseIndicatorIcon = change > 0 ? TradeUpIcon : TradeDownIcon;
  const expenseIndicatorColor = change > 0 ? 'red' : 'green'; // Adjust if inverted
  const IconComponent = categoryIconMap[category?.toLowerCase()] || TvSmartIcon;

  return (
    <Box
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        background: isHovered
          ? "linear-gradient(135deg, #ffffff 0%, #b3c7f7 100%)" 
          : "linear-gradient(135deg, #ffffff 0%, #dfe9ff 100%)", 
        borderRadius: 3,
        boxShadow: isHovered
          ? "0px 4px 12px rgba(0,0,0,0.15)" 
          : "0px 2px 6px rgba(0,0,0,0.1)",  
        border: "1px solid #FEFEFF",
        width: 250,
        p: 2,
        position: "relative",
        cursor: "default",
        display: "flex",
        flexDirection: "column",
        transition: "all 0.3s ease", // smooth hover effect
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: -10,
          left: 2,
          bgcolor: '#007bff',
          color: 'white',
          fontSize: 14,
          fontWeight: 'bold',
          px: 1.5,
          py: 0.5,
          borderRadius: 3,
          textTransform: 'capitalize',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          userSelect: 'none',
        }}
      >
        {category}
      </Box>

      {/* Content */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
        <Box>
          <Typography sx={{ fontSize: 10, fontWeight: 500, color: 'black' }}>Total Spend</Typography>
          <Typography sx={{ fontSize: 13, fontWeight: 500, lineHeight: '24px', letterSpacing: 0.5 }}>
            {title}
          </Typography>
          <Typography sx={{ fontSize: 14, fontWeight: 500, mt: 1 }}>
            ₹ {amount?.toLocaleString()}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <HugeiconsIcon icon={IconComponent} size={25} style={{ borderRadius: 10 }} />
          <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
            <Typography sx={{ fontSize: 12, color: expenseIndicatorColor, fontWeight: 400 }}>
              {change > 0 ? `+${change}%` : `${change}%`}
            </Typography>
            <HugeiconsIcon
              icon={ExpenseIndicatorIcon}
              size={18}
              style={{ color: expenseIndicatorColor }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Card;